import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function Gift() {
  return <section className="w-full bg-[#faf4ec] px-6 py-16 sm:py-24" data-id="element-84" data-mp="14x4xuwyzrove">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.7
    }} className="mx-auto max-w-2xl text-center" data-id="element-85" data-mp="1ivcnejtp7nwj">
        <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-[#b06a4a]/12 text-[#b06a4a]" data-id="element-86" data-mp="1srxvxf4xfh54">
          <GiftIcon className="h-7 w-7" data-id="element-87" data-mp="1nsuyafra0d76" />
        </span>
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#b06a4a]" data-id="element-88" data-mp="21ksu5ovz8cle">
          El regalo
        </p>
        <h2 className="font-serif text-2xl font-medium leading-snug text-[#3a2e28] sm:text-3xl" data-id="element-89" data-mp="1xl0p3m5skoks">
          Esta guía es completamente gratuita.
        </h2>
        <div className="mt-6 space-y-4 text-base leading-relaxed text-[#5c4d44]" data-id="element-90" data-mp="26lp4olau2wzs">
          <p data-id="element-91" data-mp="3gqi3fk85b1c9">
            No porque no tenga valor — sino porque hay momentos en que lo más
            importante no es vender. Este es uno de esos momentos.
          </p>
          <p className="font-serif text-lg italic text-[#8f5238]" data-id="element-92" data-mp="3lrfllwt5nvdr">
            Mi único pedido: si te ayudó, compártela con alguien que también la
            necesite. Así, entre todos, nos sostenemos.
          </p>
        </div>
      </motion.div>
    </section>;
}